"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1GetSignupPromo = void 0;
exports.v1GetSignupPromoSetMock = v1GetSignupPromoSetMock;
exports.v1GetSignupPromo = v1GetSignupPromo;
exports.useQueryV1GetSignupPromo = useQueryV1GetSignupPromo;
exports.useInfiniteQueryV1GetSignupPromo = useInfiniteQueryV1GetSignupPromo;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1GetSignupPromoSetMock(mock) {
    setMock = mock;
}
async function v1GetSignupPromo(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v1/checkout/signup-promo`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.machineId = params.machineId;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1GetSignupPromo = 'cockatoo:v1GetSignupPromo:get';
function useQueryV1GetSignupPromo(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetSignupPromo, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1GetSignupPromo(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1GetSignupPromo, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1GetSignupPromo(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-get-signup-promo.js.map